import React from 'react';
import { IconProps } from '.';

const SvgCircleTikTok = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path fill='#000' d='M23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11Z' />
      <path
        fill='#FF004F'
        d='M15.02 10.053a5.46 5.46 0 0 0 3.194 1.026v-2.3c-.225 0-.45-.024-.67-.07v1.81a5.462 5.462 0 0 1-3.195-1.026v4.695a4.244 4.244 0 0 1-4.237 4.252 4.206 4.206 0 0 1-2.359-.72c.77.79 1.843 1.28 3.03 1.28a4.244 4.244 0 0 0 4.237-4.252v-4.694Zm.827-2.32a3.212 3.212 0 0 1-.827-1.877V5.56h-.636a3.22 3.22 0 0 0 1.463 2.173Zm-6.614 8.186a1.942 1.942 0 0 1-.395-1.178 1.941 1.941 0 0 1 2.526-1.854v-2.351a4.26 4.26 0 0 0-.67-.04v1.831a1.941 1.941 0 0 0-2.526 1.854c0 .76.433 1.417 1.065 1.738Z'
      />
      <path
        fill='#fff'
        d='M14.349 9.493a5.463 5.463 0 0 0 3.194 1.026V8.71a3.204 3.204 0 0 1-1.696-.976 3.22 3.22 0 0 1-1.463-2.173h-1.67v9.188a1.942 1.942 0 0 1-1.938 1.938c-.63 0-1.189-.301-1.543-.767a1.946 1.946 0 0 1-1.066-1.738 1.942 1.942 0 0 1 2.526-1.854v-1.83a4.245 4.245 0 0 0-4.147 4.25c0 1.158.46 2.207 1.207 2.974.675.454 1.486.719 2.36.719a4.244 4.244 0 0 0 4.236-4.252V9.493Z'
      />
      <path
        fill='#00F2EA'
        d='M17.543 8.709v-.49c-.6.001-1.187-.167-1.696-.486a3.2 3.2 0 0 0 1.696.976Zm-3.16-3.149a3.262 3.262 0 0 1-.034-.264V5h-2.306v9.188a1.942 1.942 0 0 1-2.81 1.73c.354.467.913.768 1.543.768a1.942 1.942 0 0 0 1.938-1.938V5.56h1.67Zm-3.69 4.937v-.521a4.244 4.244 0 0 0-4.818 4.212c0 1.472.746 2.77 1.878 3.533a4.245 4.245 0 0 1-1.207-2.973 4.245 4.245 0 0 1 4.147-4.251Z'
      />
    </svg>
  );
};

export default SvgCircleTikTok;
